// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.color-26c6da[data-v-30dda3ce]{\n    color: #26c6da;\n    font-size: 2.125rem;\n    font-weight: 900;\n}\n", ""]);
// Exports
module.exports = exports;
